module.exports = __webpack_public_path__ + "static/media/animal-jaguar1.3faa62da.aac";